const create = (options) => {
  return {
    label: options.label || "",
    width: options.width || 0,
    height: options.height || 0,
    borderRadius: options.borderRadius || [0, 0, 0, 0],
    grid: {
      columns: options.grid.columns || 2,
      rows: options.grid.rows || 2
    },
    guides: {
      safearea: options.guides.safearea || [0, 0, 0, 0]
    },
    overlay: options.overlay || null
  };
};

export default {
  create
};
